<template>
    <div class="page-header signup-page header-filter" filter-color="orange">
        <div class="page-header-image"
             style="background-image: url('img/homepage/loginHero2.jpg')">
        </div>
        <div class="content">
            <div class="container">
                <div class="row">
                <div class="col-md-4 ml-auto mr-auto">
                    <card type="login" plain>
                        <div slot="header" class="logo-container" style="min-width='150px' !important">
                            <!-- <img v-lazy="'img/homepage/logo.png'" alt=""> -->
                            Manage Subscription
                        </div>


                        <fg-input class="no-border input-lg"
                                  v-model="email"
                                  addon-left-icon="now-ui-icons users_circle-08"
                                  placeholder="Email">
                        </fg-input>

                        <template slot="raw-content">
                          <div v-if="emailSubscribe == true">
                            <div class="card-footer text-center">
                                <a @click="login()" class="btn btn-primary btn-round btn-lg btn-block">Manage</a>
                            </div>
                          </div>
                          <div v-if="emailSubscribe == false">
                            <div class="card-footer text-center">
                                <a class="btn btn-primary btn-round btn-lg btn-block" disabled>
                                  <svg
                                    width="20"
                                    version="1.1"
                                    id="L3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    x="0px"
                                    y="0px"
                                    viewBox="0 0 100 100"
                                    enable-background="new 0 0 0 0"
                                    xml:space="preserve"
                                  >
                                    <circle
                                      fill="none"
                                      stroke="#fff"
                                      stroke-width="4"
                                      cx="50"
                                      cy="50"
                                      r="44"
                                      style="opacity:0.5;"
                                    />
                                    <circle
                                      fill="#fff"
                                      stroke="#e74c3c"
                                      stroke-width="3"
                                      cx="8"
                                      cy="54"
                                      r="6"
                                    >
                                      <animateTransform
                                        attributeName="transform"
                                        dur="2s"
                                        type="rotate"
                                        from="0 50 48"
                                        to="360 50 52"
                                        repeatCount="indefinite"
                                      />
                                    </circle>
                                  </svg>
                                </a>
                            </div>
                          </div>

                            <!-- <div class="card-footer text-center">
                                <a href="/#/membersRegisteration" class="btn btn-neutral btn-round btn-lg btn-block">Create Account</a>
                            </div> -->
                            <br>
                            <!-- <div class="pull-center">
                                <h6>
                                    <a href="/#/membersRegisteration" class="link footer-link">Create Account</a>
                                </h6>
                            </div> -->
                            <!-- <div class="pull-right">
                                <h6>
                                    <a href="#pablo" class="link footer-link">Need Help?</a>
                                </h6>
                            </div> -->
                        </template>
                    </card>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { Card, Button, FormGroupInput } from '@/components';
  import MainFooter from '@/layout/MainFooter';
  import db from '../../components/Firebase/firebaseInit'
  import firebase from 'firebase';
  import { StripeCheckout } from '@vue-stripe/vue-stripe';

  export default {
    name: 'login-page',
    bodyClass: 'login-page',
    components: {
      Card,
      StripeCheckout,
      MainFooter,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput
    },
    data() {
         this.publishableKey = 'pk_live_51IN97OKdbJJr9GC2Qi97mYou5pY79RL215MwTV6iKre9BTcno9IrRQwIiA2ioW1YHoVWc3mNz3UnK0IfqPu8Mmzv00WrQPMeQm';
        return {
        emailSubscribe: true,
        email: '',
        password: '',
        loading: false,
        lineItemsOne: [
          {
            price: 'price_1ITUQKKdbJJr9GC2GHPENg9n', // The id of the recurring price you created in your Stripe dashboard
            quantity: 1,
          },
        ],
        lineItemsTwo: [
          {
            price: 'price_1ITUQjKdbJJr9GC24eUf4Mko', // The id of the recurring price you created in your Stripe dashboard
            quantity: 1,
          },
        ],
        lineItemsThree: [
          {
            price: 'price_1ITUPLKdbJJr9GC2pl64sh3A', // The id of the recurring price you created in your Stripe dashboard
            quantity: 1,
          },
        ],
        lineItemsFour: [
          {
            price: 'price_1ITUULKdbJJr9GC2JM0PrKYm', // The id of the recurring price you created in your Stripe dashboard
            quantity: 1,
          },
        ],
        successURL: 'https://racinginfo.com.au',
        cancelURL: 'https://racinginfo.com.au',
    };
  },
    methods: {
    login () {
      this.emailSubscribe = false;
      const axios = require('axios');
      const qs = require('querystring');
      const url =
        'https://us-central1-aightbetnow-com.cloudfunctions.net/sendMail';

          const requestBody = {
            email: this.email
          }

          const config = {
            headers: {
              // 'Content-Type': 'application/x-www-form-urlencoded',

            }
          }

          axios.post(url, qs.stringify(requestBody), config)
            .then((result) => {
              // console.log(result.statusCode + " is the status");
              alert('We have sent you a link to manage your account. Go to your email and follow the link.');
              this.emailSubscribe = true;
              this.email = '';
            })
            .catch((err) => { 
              console.log(err + ' is the error')
              alert('Error subscribing');
               this.emailSubscribe = true;
            })
    }
  } 
  }
</script>
<style scoped>
.login-page .card-login .logo-container {
    width: 200px;
} 
.page-header{
max-height: 9999px !important;
}
</style>
